import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  role?: 'store' | 'system';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, role = 'store' }) => {
  const { isAuthenticated, userRole } = useAuthContext();

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (role === 'store' && userRole === 'system') {
    return <Navigate to="/system-admin" />;
  }

  if (role === 'system' && userRole !== 'system') {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};